<script>
import { defineComponent } from 'vue'
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'

export default defineComponent({
  name: 'TeamEditPage',
  components: { TwCard, TwContainer },
  props: {
    teamId: {
      type: Number,
      required: true
    }
  }
})
</script>

<template>
  <tw-container>
    <h3 class="my-6">
      Team Editing
    </h3>
    <p class="text-gray-600 mb-4">
      This is the Editor for your team. Here you can manage your team settings.
    </p>
    <tw-card class="bg-white">
      <p>Team ID: {{ teamId }}</p>
      <!-- Add more team-related content here -->
    </tw-card>
  </tw-container>
</template>

<style scoped>

</style>
